/* Lip combo builder. Used by sections/shade-lip-combo.liquid (full page) and sections/home-combo.liquid (mini, two shades).
   Markup contract: root [data-lip-combo] with data-cart-url, data-pair-saving, data-error; cards [data-combo-card] with
   data-variant-id, data-price, data-name, data-thumb; tray nodes [data-combo-picked|nudge|subtotal|total|saving|submit|status].
   The saving shown is display only: Shopify's automatic discount applies the real one in the bag. */
(() => {
'use strict';
document.querySelectorAll('[data-lip-combo]').forEach(root => {
 if (root.dataset.comboReady) return;
 root.dataset.comboReady = 'true';
 const cards = [...root.querySelectorAll('[data-combo-card]')];
 const picked = root.querySelector('[data-combo-picked]');
 const nudge = root.querySelector('[data-combo-nudge]');
 const submit = root.querySelector('[data-combo-submit]');
 const clear = root.querySelector('[data-combo-clear]');
 const status = root.querySelector('[data-combo-status]');
 const tip = root.querySelector('[data-combo-tip]');
 const pairSaving = Number(root.dataset.pairSaving) || 0;
 /* Optional cap (the homepage mini builder uses 2): at the cap, a new pick replaces the oldest one. */
 const max = Number(root.dataset.comboMax) || 0;
 const showNames = root.hasAttribute('data-combo-names');
 const state = new Map();
 let last = null;

 const money = cents => {
  const amount = decimals => (cents / 100).toLocaleString('en-US', {minimumFractionDigits: decimals, maximumFractionDigits: decimals});
  if (!window.SBS_MONEY_FORMAT) return amount(2);
  return window.SBS_MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => amount(key.includes('no_decimals') ? 0 : 2));
 };
 /* The stepper, tip and clear link are optional parts. */
 const show = (el, on) => { if (el) el.hidden = !on; };

 function render() {
  let count = 0, subtotal = 0;
  picked.textContent = '';
  cards.forEach(card => {
   const qty = state.get(card.dataset.variantId) || 0;
   count += qty;
   subtotal += qty * Number(card.dataset.price);
   card.classList.toggle('is-selected', qty > 0);
   card.querySelector('[data-combo-pick]').setAttribute('aria-pressed', String(qty > 0));
   const counter = card.querySelector('[data-combo-count]');
   if (counter) counter.textContent = qty;
   show(card.querySelector('[data-combo-qty]'), qty > 0);
   for (let i = 0; i < qty; i++) {
    const item = document.createElement('li');
    const img = new Image(56, 56);
    img.src = card.dataset.thumb; img.alt = card.dataset.name;
    item.append(img);
    if (showNames) { const name = document.createElement('span'); name.textContent = card.dataset.name; item.append(name); }
    picked.append(item);
   }
  });
  if (count % 2 === 1 || count === 0) {
   for (let i = 0; i < (count === 0 ? 2 : 1); i++) {
    const slot = document.createElement('li');
    slot.className = 'lip-combo__slot';
    slot.innerHTML = '<span class="visually-hidden"></span>';
    slot.firstChild.textContent = picked.dataset.emptyLabel;
    picked.append(slot);
   }
  }
  const saving = Math.floor(count / 2) * pairSaving;
  root.querySelector('[data-combo-subtotal]').textContent = money(subtotal);
  root.querySelector('[data-combo-total]').textContent = money(subtotal - saving);
  root.querySelector('[data-combo-saving]').textContent = money(saving);
  show(root.querySelector('[data-combo-subtotal-row]'), saving > 0);
  show(root.querySelector('[data-combo-saving-row]'), saving > 0);
  nudge.textContent = count === 0 ? nudge.dataset.first : count === 1 ? nudge.dataset.pair : count % 2 ? nudge.dataset.next : nudge.dataset.ready;
  submit.disabled = count < 2;
  show(clear, count > 0);
  const tipCard = last && state.get(last.dataset.variantId) ? last : null;
  show(tip, Boolean(tipCard));
  if (tipCard && tip) tip.querySelector('[data-combo-tip-text]').textContent = tipCard.dataset.tip;
  root.classList.toggle('has-items', count > 0);
 }

 function change(card, delta) {
  const id = card.dataset.variantId;
  if (delta > 0 && max) {
   let total = 0;
   state.forEach(value => { total += value; });
   if (total >= max) {
    /* Map keeps insertion order, so the first key is the oldest pick. */
    const oldest = state.keys().next().value;
    state.get(oldest) > 1 ? state.set(oldest, state.get(oldest) - 1) : state.delete(oldest);
   }
  }
  const qty = Math.max(0, (state.get(id) || 0) + delta);
  qty ? state.set(id, qty) : state.delete(id);
  if (delta > 0) last = card;
  status.textContent = '';
  render();
 }

 root.addEventListener('click', event => {
  const card = event.target.closest('[data-combo-card]');
  if (card && event.target.closest('[data-combo-pick]')) {
   /* Tap toggles: first tap adds one, tapping a selected card removes it. More of the same shade comes from the stepper. */
   change(card, state.get(card.dataset.variantId) ? -state.get(card.dataset.variantId) : 1);
  } else if (card && event.target.closest('[data-combo-step]')) {
   const step = Number(event.target.closest('[data-combo-step]').dataset.comboStep);
   change(card, step);
   /* Removing the last one hides the stepper, so hand focus back to the card. */
   if (!state.get(card.dataset.variantId)) card.querySelector('[data-combo-pick]').focus();
  } else if (event.target.closest('[data-combo-clear]')) {
   state.clear(); last = null; status.textContent = ''; render();
  }
 });

 submit.addEventListener('click', async () => {
  const items = [...state].map(([id, quantity]) => ({id: Number(id), quantity}));
  if (items.reduce((sum, item) => sum + item.quantity, 0) < 2) return;
  submit.disabled = true; submit.classList.add('is-loading'); status.textContent = '';
  try {
   const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
   const body = await res.json();
   if (!res.ok) throw new Error(body.description || root.dataset.error);
   window.location.assign(root.dataset.cartUrl);
  } catch (err) {
   status.textContent = err.message || root.dataset.error;
   submit.disabled = false; submit.classList.remove('is-loading');
  }
 });

 render();
});
})();
